module.exports = __webpack_public_path__ + "static/media/viewPass.649034aa.svg";